export function WalletIcon() {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="80"
        cy="80"
        r="80"
        fill="var(--landing-advantages-icon-bg, #E3D5BE)"
        fillOpacity="var(--landing-advantages-icon-bg-opacity, 0.24)"
      />
      <path
        d="M101.6 23.7998C109.538 23.7998 116 30.2619 116 38.2002V52.6006C123.939 52.6008 130.4 59.0619 130.4 67V113.801C130.4 121.739 123.939 128.2 116 128.2H45.8003C36.8708 128.2 29.6002 120.93 29.6001 112.001L29.6919 41.709L29.6353 40.6475C30.233 31.1975 38.115 23.7998 47.6001 23.7998H101.6ZM36.8003 112C36.8003 116.971 40.8292 121 45.8003 121H116C119.98 121 123.2 117.78 123.2 113.801V67C123.199 63.0207 119.98 59.801 116 59.8008H47.6001C43.6768 59.8008 39.8941 58.4999 36.8003 56.1797V112ZM94.3999 90.4004C94.3999 85.598 101.6 85.598 101.6 90.4004C101.6 95.2025 94.4002 95.2025 94.3999 90.4004ZM47.9097 31C42.2356 31 37.3763 35.2894 36.856 40.7598L36.8491 40.7529C36.5608 43.7974 37.573 46.8213 39.605 49.0713C41.6581 51.3071 44.5556 52.6006 47.6001 52.6006H108.799V38.2002C108.799 34.2208 105.579 31.0002 101.6 31H47.9097Z"
        fill="url(#paint0_linear_43_508)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_508"
          x1="80"
          y1="23.8008"
          x2="80"
          y2="128.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--landing-advantages-icon-color-from, #FFA24B)" />
          <stop
            offset="1"
            stopColor="var(--landing-advantages-icon-color-to, #FF7B01)"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
